import React from 'react';
import PropTypes from 'prop-types';
import defaults from 'lodash/defaults';
import Modal from '../Modal';
import Button from '../Button';

import './styles.css';

export default class GenericModal extends React.PureComponent {
  static propTypes = {
    title: PropTypes.any,
    message: PropTypes.any,
    cancelText: PropTypes.string,
    confirmText: PropTypes.string,
    onCancel: PropTypes.func,
    onConfirm: PropTypes.func,
    onClose: PropTypes.func,
    onOpen: PropTypes.func,
    mountNode: PropTypes.any,
    open: PropTypes.bool,
    // if true, dialog will render with close icon, and will close on ESC or document/dimmer click
    closeable: PropTypes.bool,
  };

  static defaultProps = {
    closeable: false,
  };

  state = { requesting: false };

  componentWillReceiveProps = (nextProps) => {
    if (!this.props.open && nextProps.open) {
      this.setState({ requesting: false });
    }
  };

  onConfirmLoading = () => {
    const { onConfirm } = this.props;
    this.setState({ requesting: true });
    if (onConfirm) onConfirm();
  };

  onCancel = () => {
    const { onCancel } = this.props;
    if (onCancel) onCancel();
  };

  onClose = () => {
    const { onClose } = this.props;
    if (onClose) onClose();
  };

  render() {
    const { title, message, cancelText, confirmText, closeable, ...rest } = this.props;
    if (closeable) {
      // apply closeOnXxx props unless they have been explicitely set
      defaults(rest, {
        closeOnDocumentClick: true,
        closeOnDimmerClick: true,
        closeOnEsc: true,
      });
    }

    return (
      <Modal size="tiny" {...rest} closeIcon={closeable ? 'close' : null} onClose={this.onClose} data-cy="save-modal" styleName="save-modal">
        <Modal.Header as="h2">
          {title}
        </Modal.Header>
        <Modal.Content styleName="text">
          {message}
        </Modal.Content>
        <Modal.Actions>
          <Button content={cancelText} onClick={this.onCancel} />
          <Button primary content={confirmText} onClick={this.onConfirmLoading} loading={this.state.requesting} />
        </Modal.Actions>
      </Modal>
    );
  }
}
